import { Campaign } from '../../../../types';

export interface CampaignsFilterOptions {
  query: string;
  /** Empty array = no task-type filter. A campaign passes when it has at
   *  least one bound task type whose id is in this list (OR semantics). */
  taskTypeIds: string[];
}

/**
 * Filter campaigns by case-insensitive name substring plus optional task-type
 * facet. Pure so it can be unit-tested without React state and reused from
 * the viewmodel.
 *
 * Task-type filter uses OR semantics — selecting "Feedback" and "Workflow
 * Map" returns every campaign that has at least one of those bound. AND
 * semantics (campaigns with BOTH types) would surprise admins who more
 * commonly want "show me everything touching this task type".
 */
export function filterCampaigns(
  campaigns: Campaign[],
  opts: CampaignsFilterOptions,
): Campaign[] {
  const q = opts.query.trim().toLowerCase();
  const typeSet = new Set(opts.taskTypeIds);
  if (!q && typeSet.size === 0) return campaigns;
  return campaigns.filter((c) => {
    if (typeSet.size > 0) {
      const hasMatch = c.taskTypes.some((t) => typeSet.has(t.taskTypeId));
      if (!hasMatch) return false;
    }
    if (!q) return true;
    return (c.name ?? '').toLowerCase().includes(q);
  });
}
